import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { VtxButton, VtxIcon } from '@vertexinc/vtx-ui-react-component-library';
import ColumnButtonProps from './ColumnButtonProps.interface';
import './column-button.scss';

const ColumnButton = ({
  id,
  icon = null,
  iconSize = 20,
  iconPlacement = 'left',
  row,
  onClick,
  buttonText,
  buttonType = 'primary',
  align = 'left',
}: ColumnButtonProps): JSX.Element => {
  Logging.Debug('Column Icon');

  return (
    <>
      <div key={id} className={`columnButton columnButtonAlign${align}`}>
        <VtxButton
          id={id}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onClick={(event: any) => onClick(row)}
          icon={icon ? <VtxIcon type={icon} fontSize={iconSize} /> : null}
          type={buttonType}
          iconDirection={iconPlacement}
        >
          {buttonText}
        </VtxButton>
      </div>
    </>
  );
};

export default ColumnButton;
